import { render, staticRenderFns } from "./ConfigureRatesDialog.vue?vue&type=template&id=118bb8aa&scoped=true"
import script from "./ConfigureRatesDialog.vue?vue&type=script&lang=js"
export * from "./ConfigureRatesDialog.vue?vue&type=script&lang=js"
import style0 from "./ConfigureRatesDialog.vue?vue&type=style&index=0&id=118bb8aa&prod&lang=css"
import style1 from "./ConfigureRatesDialog.vue?vue&type=style&index=1&id=118bb8aa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "118bb8aa",
  null
  
)

export default component.exports